import { Milliseconds } from '@kameleoon/javascript-sdk-core';

export const DEFAULT_CLEANUP_INTERVAL = 30;
export const DEFAULT_REQUEST_TIMEOUT = 10 * Milliseconds.Second;
